export const FieldStatus = {
    Keep: 1,
    Disable: 2,
    ShowEnabled: 3,
    ShowDisabled: 4,

    isVisible: (status) => status !== FieldStatus.Disable,
    isEnabled: (status) => status === FieldStatus.Keep || status === FieldStatus.ShowEnabled,
    isEditable: (status) => status !== FieldStatus.Disable,
    isDisabled: (status) => status === FieldStatus.Disable,
    isShowEnabled: (status) => status === FieldStatus.ShowEnabled,
    isShowDisabled: (status) => status === FieldStatus.ShowDisabled
};